(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('jmrsignApp')
        .constant('VERSION', "2.0.1")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
